import { useAuth0 } from "@auth0/auth0-react";
import * as Sentry from "@sentry/react";
import { useEffect } from "react";

import { useInfo } from "@/context/InfoProvider/InfoProvider";

export function useSentryUser() {
  const { user, isAuthenticated } = useAuth0();
  const { currentOrganization } = useInfo();

  useEffect(() => {
    if (isAuthenticated && user) {
      const userData = {
        cmsUserId: user.cms_user_id,
        cmsOrgId: user.cms_org_id,
        emailDomain: user.email?.split("@")[1],
        tenantId: currentOrganization?.insightsTenantId,
        organizationName: currentOrganization?.name,
      };
      Sentry.setUser(userData);
    } else {
      Sentry.setUser(null);
    }
  }, [isAuthenticated, user, currentOrganization]);
}
